import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';

export default function AdminRoutes() {
    const { user } = useAuth();
    const isAdmin = user ? user.labels.includes('admin') : false;

    return isAdmin ? <Outlet /> : <Navigate to="/" />;
}